
export enum ESideKickRequestStatus {
  pending = 'pending',
  completed = 'completed'
}

/**
 * Canonical shape of a completed commit-message suggestion. Shared by both
 * delivery paths: the SignalR push (main success scenario) and the synchronous
 * HTTP fallback used when the SignalR completion message is lost.
 */
export interface CommitMessageSuggestion {
  title: string;
  description: string;
  releaseNotes: string;
}